import { combineReducers } from '@reduxjs/toolkit';
// import userReducer from './userReducer';

import reportViewDialogReducer from './reportViewDialogReducer';
import filterParamsReducer from './filterParamsReducer'

const reducer = combineReducers({
	reportViewDialogReducer,
	filterParamsReducer
});

export default reducer;
